"use client";

import Image from "next/image";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

export default function ProjectConcept() {

    return (
        <div className="bg-bluebirdlightblue">
            <h1 className="text-4xl p-4 pl-12">BlueBird Components</h1>
            <p className="pl-12 pr-12 pb-4">
                The Bluebird platform consists of a set of <strong>generic components</strong> which will be deployed in the project pilots depending on the pilots' use case needs.
            </p>
            <p className="pl-12 pr-12 pb-4">
                The overall architecture allows to integrate seamlessly with existing IoT infrastructures in the different pilot sites, while ensuring that the minimum 
                requirements are met for deploying the full suite of BlueBird services. This architecture strikes a balance between <strong>flexibility</strong> and <strong>robustness</strong>, 
                providing a versatile foundation for energy data management and demand response applications.
            </p>
            <p className="pl-12 pr-12 pb-4">
                This strategy ensures that the deployment of BlueBird services is <strong>sustainable</strong> in the long term. After the project, partners will be able to continue 
                providing and scaling the developed services within their own infrastructures, maintaining the value created and supporting ongoing innovation in energy management and flexibility services.
            </p>
            <div className="relative w-full max-w-4xl mx-auto">
                {/* Wrapper for Image and Hotspots */}
                <div className="relative w-full aspect-[3/2]">
                    {/* Main figure */}
                    <Image
                        src="/projectoverview/projectconcept-nobg-new.png"
                        alt="Project Concept"
                        width={900}
                        height={200}
                        className="object-cover"
                    />

                    {/* --- Hotspot 1: User Interaction Tools --- */}
                    <div
                        data-tooltip-id="user-interaction-tooltip"
                        data-tooltip-html="Assess and strengthen<br /> user engagement"
                        className="absolute top-[21%] left-[8%] w-[27%] h-[25%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                    {/* --- Hotspot 2: Forecasting --- */}
                    <div
                        data-tooltip-id="forecasting-tooltip"
                        data-tooltip-content="Forecasts of external conditions"
                        className="absolute top-[54%] left-[25.5%] w-[12.5%] h-[38%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                    {/* --- Hotspot 3: Orchestration --- */}
                    <div
                        data-tooltip-id="orchestration-tooltip"
                        data-tooltip-content="Deployment of Dockerised components"
                        className="absolute top-[57.5%] left-[0.9%] w-[18.5%] h-[27%] rounded-full /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                    {/* --- Hotspot 4: Data Exchange Connectors --- */}
                    <div
                        data-tooltip-id="connectors-tooltip"
                        data-tooltip-html="Forwarding of control signals<br /> to flexible assets"
                        className="absolute top-[36.5%] left-[39.5%] w-[23%] h-[12%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                    {/* --- Hotspot 5: Flexibility Manager --- */}
                    <div
                        data-tooltip-id="flexibility-manager-tooltip"
                        data-tooltip-html="Identification of building flex capacity,<br /> and asset control optimization"
                        className="absolute top-[59%] left-[44%] w-[24.5%] h-[17%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                    {/* --- Hotspot 6: Digital Twin --- */}
                    <div
                        data-tooltip-id="digital-twin-tooltip"
                        data-tooltip-content="Digital twin models of buildings and flexible assets"
                        className="absolute top-[81%] left-[44%] w-[15%] h-[11.5%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />

                    {/* --- Hotspot 7: Trading Manager --- */}
                    <div
                        data-tooltip-id="trading-manager-tooltip"
                        data-tooltip-html="Calculation of flex bidding prices <br /> towards energy markets"
                        className="absolute top-[38%] left-[73%] w-[26%] h-[27%] /*bg-red-500/40 hover:bg-blue-500/40*/ cursor-pointer z-10"
                    />
                </div>

                {/* Tooltips */}
                <ReactTooltip id="user-interaction-tooltip" place="top" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />
                <ReactTooltip id="forecasting-tooltip" place="left" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />
                <ReactTooltip id="orchestration-tooltip" place="top" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />
                <ReactTooltip id="connectors-tooltip" place="top" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />
                <ReactTooltip id="flexibility-manager-tooltip" place="top" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />
                <ReactTooltip id="digital-twin-tooltip" place="right" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />
                <ReactTooltip id="trading-manager-tooltip" place="bottom" className="!bg-bluebirdyellow !text-black !rounded-md !opacity-100" />

                <p className="text-right text-sm mb-4 italic">
                    💡 Hover over the different components for more information
                </p>
            </div>
        </div>
    )
}